import { datadogRum } from '@datadog/browser-rum';
import { isClient } from '@mop/shared/utils/util';

function CustomError(error: Error) {
  // @ts-ignore
  this.name = error?.name ?? 'CustomError';
  // @ts-ignore
  this.message = error?.message ?? 'CustomError';
  // @ts-ignore
  this.stack = error?.stack ?? '';
}

CustomError.prototype = Object.create(Error.prototype);

export default defineNuxtPlugin((nuxtApp) => {
  if (!isClient || isLinux()) {
    return;
  }
  const config = nuxtApp.$config;
  const applicationId: string = config.public.DATADOG_APP_KEY ?? '';
  const clientToken: string = config.public.DATADOG_TOKEN ?? '';
  const version: string = config.public.BUILD_ID ?? '';
  if (!applicationId || !clientToken) {
    return;
  }
  const productionHost: string = config.public.DATADOG_APPLICATION_NAME;

  datadogRum.init({
    applicationId,
    clientToken,
    env: config.public.RUNTIME_ENVIRONMENT,
    site: 'datadoghq.com',
    service: productionHost,
    version,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  // @ts-ignore
  window.appInsights = {
    trackException({ exception }: { exception: Error }) {
      try {
        // @ts-ignore
        throw new CustomError(exception);
      } catch (error) {
        datadogRum.addError(error);
      }
    },
    trackTrace({ message, severity }: { message: string; severity: string }) {
      try {
        // @ts-ignore
        throw new CustomError({
          name: 'Trace',
          message: `Trace [${severity}]: ${message}`,
        });
      } catch (error) {
        datadogRum.addError(error);
      }
    },
    flush() {},
  };

  nuxtApp.provide('datadog', datadogRum);
});
